import React, { useContext, useEffect, useState } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import close_arrow from '../Assets/close_arrow.png';
import PaystackCheckout from '../Paystack/PaystackCheckout.jsx';
import axios from 'axios';
import { usePaystackPayment } from 'react-paystack';
import { useNavigate } from 'react-router-dom';


const CartItems = () => {
    const { getTotalCartAmount, all_product, cartItems, addToCart, removeFromCart, getCartData, clearCart } = useContext(ShopContext);
    const { cartData } = useContext(ShopContext);
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://mamadora-backend.onrender.com';

    if (!cartData || cartData.length === 0) return <p>Your cart is empty.</p>;

    const cartEntries = Object.entries(cartData).filter(([_, qty]) => qty > 0);


    const [loyaltyPoints, setLoyaltyPoints] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [applied, setApplied] = useState(false);
    const [userEmail, setUserEmail] = useState('');

    const subtotal = getTotalCartAmount();
    const finalTotal = subtotal - discount;

    const publicKey = 'pk_live_8ca45653f6eec46ee69cd887767188103719cab9';

    const config = {
        reference: new Date().getTime().toString(),
        email: userEmail || 'Dorafoodandspices@gmail.com',
        amount: finalTotal * 100,
        publicKey: publicKey,
    };

    const initializePayment = usePaystackPayment(config);

    useEffect(() => {
        fetchLoyaltyPoints();
        fetchUserEmail();
    }, []);

    const fetchUserEmail = async () => {
        try {
            const token = localStorage.getItem('auth-token');
            if (!token) return;
            const res = await axios.get(
                `${backendUrl}/get-user-email`,
                { headers: { 'auth-token': token } }
            );
            if (res.data.success) {
                setUserEmail(res.data.email);
            }
        } catch (err) {
            console.error('Error fetching user email:', err);
        }
    };

    const fetchLoyaltyPoints = async () => {
        try {
            const token = localStorage.getItem('auth-token');
            if (!token) {
                console.warn("No auth-token found. Loyalty points not fetched.");
                return;
            }
            const res = await axios.post(
                `${backendUrl}/getloyaltypoints`,
                {},
                {
                    headers: { 'auth-token': token },
                }
            );
            setLoyaltyPoints(res.data.loyaltyPoints);
        } catch (err) {
            console.error('Error fetching loyalty points:', err);
        }
    };

    const applyPoints = () => {
        if (!applied) {
            const maxUsable = Math.min(loyaltyPoints, subtotal);
            setDiscount(maxUsable);
            setApplied(true);
        }
    };
    const navigate = useNavigate();

    const handleCheckout = () => {
        if (!userEmail) {
            alert("Please log in to proceed with checkout.");
            return;
        }

        initializePayment(
            async (reference) => {
                console.log("Payment Successful:", reference);

                try {
                    const token = localStorage.getItem('auth-token');
                    if (!token) {
                        console.warn("No auth-token found. Order not saved.");
                        alert("Payment successful but couldn't save order. Please login.");
                        return;
                    }

                    // Verify payment first
                    const verifyRes = await axios.post(
                        `${backendUrl}/verify-payment`,
                        { reference: reference.reference }
                    );

                    if (!verifyRes.data.success) {
                        alert("Payment verification failed. Please contact support.");
                        return;
                    }

                    // Build items array with details for the email
                    const orderItems = cartData.map(item => ({
                        name: item.product?.name || 'Product',
                        quantity: item.quantity || 1,
                        price: (item.product?.new_price || 0) * (item.quantity || 1),
                        productId: item.product?._id,
                    }));

                    // Save order + send email + clear cart (backend handles all)
                    await axios.post(
                        `${backendUrl}/save-order`,
                        {
                            items: orderItems,
                            total: finalTotal,
                            email: userEmail,
                        },
                        {
                            headers: { 'auth-token': token }
                        }
                    );

                    // Clear cart on the frontend
                    clearCart();
                    navigate('/success');
                } catch (err) {
                    console.error("Failed to save order or send email:", err);
                    alert("Payment went through but we couldn't save your order. Please contact support.");
                }
            },
            (error) => {
                console.error("Payment Failed:", error);
            }
        );
    };

    useEffect(() => {
        getCartData();
    }, []);



    useEffect(() => {
        const fetchCart = async () => {
            try {
                const res = await fetch(`${backendUrl}/getcart`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "auth-token": localStorage.getItem("auth-token"),
                    },
                });


                const text = await res.text();
                console.log("Raw cart response:", text);


                let data;
                try {
                    data = JSON.parse(text);
                } catch {
                    console.error("Response was not valid JSON");
                    return;
                }

                console.log("Fetched cart data:", data);


            } catch (err) {
                console.error("Error fetching cart:", err);
            }
        };

        fetchCart();
    }, []);

    return (
        <div className="cartitems">
            <div className="cartitems-format-main">
                <p>Products</p>
                <p>Title</p>
                <p>Price</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>
            <hr />


            {cartData && cartData.length > 0 ? (
                cartData.map((item) => (
                    <div key={item._id} className="cartitems-format cartitems-format-main">
                        <img
                            src={item.product.image.startsWith('http') ? item.product.image : `${backendUrl}/image/${item.product.image}`}
                            alt={item.product.name}
                            className="cartitems-product-icon"
                        />
                        <p>{item.product.name}</p>
                        <p>₦{item.product.new_price}</p>
                        <div className="cartitems-qty-controls">
                            <button className="qty-btn qty-minus" onClick={() => removeFromCart(item.product._id)}>−</button>
                            <span className="qty-count">{item.quantity}</span>
                            <button className="qty-btn qty-plus" onClick={() => addToCart(item.product._id)}>+</button>
                        </div>
                        <p>₦{item.product.new_price * item.quantity}</p>
                        <img
                            src={close_arrow}
                            alt="Remove"
                            className="cartitems-remove-icon"
                            onClick={() => removeFromCart(item.product._id)}
                        />
                    </div>
                ))
            ) : (
                <p></p>
            )}

            <div className="cartitems-down">
                <div className="cartitems-total">
                    <h1>Cart Totals</h1>

                    <div className="cartitems-total-items">
                        <p>Subtotal</p>
                        <p>₦{subtotal}</p>
                    </div>

                    <div className="cartitems-total-items">
                        <p>Shipping Fee</p>
                        <div className="cart-words">
                            <p>Disclaimer:This price is not inclusive of delivery.</p>
                        </div>

                    </div>

                    {applied && (
                        <div className="cartitems-total-items">
                            <p>Points Applied</p>
                            <p>-₦{discount}</p>
                        </div>
                    )}

                    <hr />

                    <div className="cartitems-total-items">
                        <h3>Total</h3>
                        <h3>₦{finalTotal}</h3>
                    </div>

                    <p>Available Loyalty Points: {loyaltyPoints}</p>
                    <button onClick={applyPoints} disabled={applied}>
                        {applied ? 'Points Applied' : 'Use Loyalty Points'}
                    </button>

                    <button onClick={handleCheckout}>PROCEED TO CHECKOUT</button>
                </div>

                <div className="cartitems-promocode">
                    <p>If you have a promo code, Enter it here</p>
                    <div className="cartitems-promobox">
                        <input type="text" placeholder="promo code" />
                        <button>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartItems;